import React, { Component } from 'react';
import { render, unmountComponentAtNode as remove } from 'react-dom';
import CuratorMessage from '~/components/popups/CuratorMessage';

// Routing
import routes, { server } from '~/apiRouter';

// Components
import Loader from '~/components/ui/Loader';

export default class Contacts extends Component {
  state = {
    city: null,
    cities: [],
    managers: [],
    loading: true,
    opened: false,
  };

  componentDidMount() {
    if (this.props.manager) {
      // Load popup with specific manager
      this.loadManager();
    } else {
      // Aside block or popup on course pages
      this.loadData();
    }
  }

  loadManager() {
    const { manager } = this.props;

    const headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    };

    const fetchUrl = `${routes.designer.manager}${manager}`;

    fetch(fetchUrl, headers)
      .then(response => response.json())
      .then(response => {
        if (response.status === 'success') {
          this.setState({
            managers: [response.data.MANAGER] || [],
            loading: false,
          });
        } else {
          this.setState({
            error: response.errors
              ? response.errors.map(e => e.message)
              : ['Ошибка загрузки данных по менеджерам'],
            loading: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          error: [`Ошибка получения менеджеров от сервера: ${error.message}`],
          loading: false,
        });
      });
  }

  loadData() {
    const { page, currentCity, onChange } = this.props;

    const headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    };

    const fetchUrl = `${routes.designer.get}${page}/manager`;

    fetch(fetchUrl, headers)
      .then(response => response.json())
      .then(response => {
        if (response.status === 'success') {
          const cities = Object.keys(window.city).map(
            city => window.city[city],
          );
          const city = currentCity || cities.filter(c => c.CURRENT).pop();

          if (typeof onChange !== 'undefined') {
            const currentManager = response.data.MANAGERS.filter(
              m => m.CITY.ID === city.ID,
            ).pop();
            const managerID = currentManager ? currentManager.ID : null;
            onChange(managerID);
          }

          this.setState({
            managers: response.data.MANAGERS || [],
            cities,
            city,
            loading: false,
          });
        } else {
          this.setState({
            error: response.errors
              ? response.errors.map(e => e.message)
              : ['Ошибка загрузки данных по кураторам'],
            loading: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          error: [`Ошибка получения кураторов от сервера: ${error.message}`],
          loading: false,
        });
      });
  }

  onSubmit() {
    window.location.href = 'mailto:academy.registration@email.tedo.ru?subject=Академия ТеДо: вопрос с сайта';

    // const { inPopup, page, onSubmit } = this.props;
    // const { city } = this.state;

    // if (inPopup) {
    //   onSubmit();
    // } else {
    //   $.magnificPopup.open({
    //     items: {
    //       src: '#popup',
    //     },
    //     removalDelay: 250,
    //     closeOnBgClick: false,
    //     callbacks: {
    //       beforeOpen() {
    //         this.st.mainClass = 'mfp-anim';
    //       },
    //       open() {
    //         render(<CuratorMessage city={city} page={page} />, $('#popup')[0]);
    //       },
    //       close() {
    //         remove($('#popup')[0]);
    //       },
    //     },
    //   });
    // }
  }

  changeCity(city) {
    const { onChange } = this.props;
    const { managers } = this.state;

    this.setState({
      city,
      opened: false,
    });

    // If have props onChange, then send to parent
    if (typeof onChange !== 'undefined') {
      const currentManager = managers.filter(m => m.CITY.ID == city.ID).pop();
      const managerID = currentManager ? currentManager.ID : null;
      onChange(managerID);
    }
  }

  prepareTownSelect() {
    const { cities, city, opened } = this.state;
    const options = cities.map(c => {
      const classes = ['town__link'];
      if (c.ID === city.ID) classes.push('is-active');
      return (
        <button
          key={c.ID}
          className={classes.join(' ')}
          onClick={() => this.changeCity(c)}
        >
          {c.NAME}
        </button>
      );
    });

    const classes = ['course-contacts__town', 'town'];
    if (opened) classes.push('is-open');

    return (
      <div className={classes.join(' ')}>
        <button
          type="button"
          className="town__choice"
          onClick={() => this.setState({ opened: !opened })}
        >
          <span>{city?.NAME}</span>
        </button>
        <div className="town__drop">{options}</div>
      </div>
    );
  }

  prepareManager() {
    const { inPopup, manager } = this.props;
    const { city, managers } = this.state;

    const currentManager = manager ? managers[0] : managers.filter(m => m.CITY.ID == city.ID).pop();

    if (currentManager === undefined) return null;
    let photo = currentManager.PREVIEW_PICTURE.SRC;
    if (process.env.NODE_ENV === 'development') {
      photo = `${server}${photo}`;
    }

    let btnText = 'Задать вопрос';
    if (inPopup) btnText = 'Отправить';

    return (
      <React.Fragment>
        <div className="course-contacts__manager">
          <div
            className="course-contacts__img"
            style={{
              backgroundImage: `url('${photo}')`,
            }}
          />
          <div className="course-contacts__info">
            <p className="name">{currentManager.NAME}</p>
            <p className="tel">{currentManager.PROPERTY_PHONE_VALUE}</p>
          </div>
        </div>
        <button
          type="button"
          className={
            inPopup
              ? 'btn btn--primary course-contacts__btn'
              : 'btn btn--outline course-contacts__btn'
          }
          onClick={() => this.onSubmit()}
        >
          {btnText}
        </button>
      </React.Fragment>
    );
  }

  render() {
    const { loading } = this.state;
    const { manager } = this.props;

    if (loading) return <Loader />;

    return (
      <div className="course-contacts__container">
        <p className="heading heading--2 course-contacts__umakhi-header">Контакты</p>
        <div className="course-contacts">
          {manager ? null : this.prepareTownSelect()}
          {this.prepareManager()}
        </div>
      </div>
    );
  }
}
